/**
 * Modulo Page
 * @module abstracts/page
 * @namespace Abstracts/Page
 */
import Core from '../core'
import _ from 'underscore'

/**
 * Classe responsável por controlar a página
 *
 * @name Page
 * @typedef {Object} Page
 * @memberof abstracts/page
 */
class Page {
    /**
     * @property {'mobile'|'desktop'} screenType - Tipo da tela
     */
    screenType

    /**
     * @property {window.screen} screen - Tamanhos da página
     */
    screen

    /**
     * @property {int} lastScrollTop - Último Scrolltop
     */
    lastScrollTop = 0
    /**
     * Inicializador da classe Page chamado manualmente
     *
     * @return {void}
     */
    init () {
        Core.Status.update('page', 'status', 'started')

        document.onreadystatechange = _.bind(this._listenDocumentState, this)

        this._setPagesAtributtes()

        this._listenDocumentState()

        this._listenScroll()

        this._listenPageBottom()

        this._listenScrollDirection()

        this._listenPageFocus()

        this._checkWorkingStatus()
    }

    /**
     * Seta os atributos principais da página
     *
     */
    _setPagesAtributtes () {
        this.screen = window.screen

        this.screenType = window.screen.width > 767 ? 'desktop' : 'mobile'
    }

    /**
     * Listerner que verifica o status de carregamento da página
     *
     * @see https://developer.mozilla.org/pt-BR/docs/Web/API/Document/readyState
     */
    _listenDocumentState () {
        switch (document.readyState) {
        case 'loading':
            this._trigger('loading')
            break

        case 'interactive':
            this._trigger('loading')
            this._trigger('interactive')
            break

        case 'complete':
            // Envio todos os métodos porque há risco de quando o modulo page for carregado
            // A página já tenha completado o loading ou o interactive
            this._trigger('loading')
            this._trigger('interactive')
            this._trigger('complete')
            break
        }
    }

    /**
     * Verifica se os eventos da page já foram disparado senão o dispara
     *
     * @param {string} state - Nome do estado da página loading|interactive|complete
     * @return {void}
     */
    _trigger (state) {
        switch (state) {
        case 'loading':
            if (!Core.Status.getHistory('page', 'status').indexOf('loading') !== -1) {
                Core.Status.update('page', 'status', 'loading')
                Core.Events.Dispatcher.trigger(Core.Events.PAGE_LOADING)
            }
            break

        case 'interactive':
            if (!Core.Status.getHistory('page', 'status').indexOf('interactive') !== -1) {
                Core.Status.update('page', 'status', 'interactive')
                Core.Events.Dispatcher.trigger(Core.Events.PAGE_READY)
            }
            break

        case 'complete':
            if (!Core.Status.getHistory('page', 'status').indexOf('finished') !== -1) {
                Core.Status.update('page', 'status', 'finished')
                Core.Events.Dispatcher.trigger(Core.Events.PAGE_COMPLETE)
            }
            break
        }
    }

    /**
     * Adiciona um listerner ao evento Scroll
     *
     */
    _listenScroll () {
        window.onscroll = () => {
            Core.Events.Dispatcher.trigger(Core.Events.PAGE_SCROLL)
        }
    }

    /**
     * Adiciona um listerner ao evento listenPageBottom
     *
     */
    _listenPageBottom () {

        let sizeArea = 650
        if (this.screenType  === 'mobile') {
            sizeArea = 1850
        }

        Core.Tasks.add(Core.Events.PAGE_SCROLL, _.throttle(() => {
            if ((window.innerHeight + document.documentElement.scrollTop) >= (document.body.offsetHeight - sizeArea)) {
                Core.Events.Dispatcher.trigger(Core.Events.PAGE_BOTTOM)
            }
        }, 1000))
    }

    _listenScrollDirection () {
        Core.Tasks.add(Core.Events.PAGE_SCROLL, () => {
            if (document.documentElement.scrollTop > JSON.parse(this.lastScrollTop)) {
                Core.Events.Dispatcher.trigger(Core.Events.PAGE_SCROLL_DOWN)
            } else if ((document.documentElement.scrollTop < JSON.parse(this.lastScrollTop))) {
                Core.Events.Dispatcher.trigger(Core.Events.PAGE_SCROLL_UP)
            }

            this.lastScrollTop = JSON.stringify(document.documentElement.scrollTop)
        })
    }

    _listenPageFocus () {
        // Evento para identificar a Aba/Janela RECEBEU o foco
        window.onfocus = _.bind(() => {
            // console.warn('Aba recebeu o foco.')
            Core.Status.update('page', 'visible', true)
            Core.Events.Dispatcher.trigger(Core.Events.PAGE_FOCUS)
        }, this)

        // Evento para identificar a Aba/Janela PERDEU o foco
        window.onblur = _.bind(() => {
            // console.warn('Aba perdeu o foco.')
            Core.Status.update('page', 'visible', false)
            Core.Events.Dispatcher.trigger(Core.Events.PAGE_BLUR)
        }, this)
    }

    /**
     * Força a finalização da página depois de 8 segundos
     * Caso ainda não tenha finalizado
     *
     */
    _checkWorkingStatus () {
        _.delay(() => {
            if (Core.Status.get('page', 'status') !== 'finished') {
                // Dispara o Marco PAGE_COMPLETE
                Core.Status.update('page', 'status', 'finished')
                Core.Events.Dispatcher.trigger(Core.Events.PAGE_COMPLETE)
            }
        }, 8000)
    }
}

window.GPAbstractModules = window.GPAbstractModules || {}
window.GPAbstractModules.Page = Page
